import i18n from "../config/i18n";

export interface ApiError {
  message: string;
  code?: string;
  status?: number;
}

interface AxiosLikeError {
  response?: {
    data?: { message?: string; code?: string };
    statusText?: string;
    status?: number;
  };
  message?: string;
  code?: string;
}

export function toApiError(error: unknown): ApiError {
  if (error && typeof error === "object") {
    const e = error as AxiosLikeError;
    if (e.response) {
      return {
        message:
          e.response.data?.message ||
          e.response.statusText ||
          i18n.t("common:errors.networkError"),
        code: e.response.data?.code,
        status: e.response.status,
      };
    }
    if ("message" in e && typeof e.message === "string") {
      return {
        message: e.message,
        code: e.code,
        status:
          "status" in error && typeof error.status === "number"
            ? error.status
            : undefined,
      };
    }
  }
  return {
    message:
      typeof error === "string"
        ? error
        : i18n.t("common:interface.unknownErrorOccurred"),
  };
}

export function isApiError(error: unknown): error is ApiError {
  return (
    error !== null &&
    typeof error === "object" &&
    "message" in error &&
    typeof error.message === "string"
  );
}
